/* cs-pdp-offers.js — PDP Offer Cards: arrows, copy-to-clipboard, terms tooltip */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.cs-pdp-offers').forEach(setup);
  }

  function setup(root) {
    var tooltip  = root.querySelector('.cs-pdp-offers__tooltip');
    var scroller = root.querySelector('.cs-pdp-offers__scroller');
    var track    = root.querySelector('.cs-pdp-offers__track');
    var btnPrev  = root.querySelector('.cs-pdp-offers__arrow--prev');
    var btnNext  = root.querySelector('.cs-pdp-offers__arrow--next');

    /* ── Copy-to-clipboard ── */
    /* Only real buttons copy — a non-copyable code renders as a plain span. */
    root.querySelectorAll('button.cs-pdp-offers__code-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { copyCode(btn); });
    });

    /* ── Arrow navigation ── */
    if (track && btnPrev && btnNext && scroller) {
      setupArrows(track, scroller, btnPrev, btnNext);
    }

    if (!tooltip) return;

    /* ── Terms tooltip ── */
    root.querySelectorAll('.cs-pdp-offers__terms-btn').forEach(function (btn) {
      btn.addEventListener('mouseenter', function (e) {
        showTip(tooltip, btn.dataset.terms, e.clientX, e.clientY);
      });
      btn.addEventListener('mouseleave', function () { hideTip(tooltip); });

      btn.addEventListener('focus', function () {
        var r = btn.getBoundingClientRect();
        showTip(tooltip, btn.dataset.terms, r.left + r.width / 2, r.top);
      });
      btn.addEventListener('blur', function () { hideTip(tooltip); });

      btn.addEventListener('touchstart', function (e) {
        e.preventDefault();
        if (tooltip.classList.contains('is-visible')) {
          hideTip(tooltip);
        } else {
          var t = e.touches[0];
          showTip(tooltip, btn.dataset.terms, t.clientX, t.clientY);
          clearTimeout(tooltip._autoHide);
          tooltip._autoHide = setTimeout(function () { hideTip(tooltip); }, 3000);
        }
      }, { passive: false });
    });

    document.addEventListener('touchstart', function (e) {
      if (!e.target.closest('.cs-pdp-offers__terms-btn')) hideTip(tooltip);
    }, { passive: true });
  }

  /* ── Arrow setup ── */
  function setupArrows(track, scroller, btnPrev, btnNext) {
    /* Scroll by ~2 card widths */
    function scrollAmount() {
      var card = track.querySelector('.cs-pdp-offers__card');
      var gap  = 14; /* matches CSS gap on desktop */
      return card ? (card.offsetWidth + gap) * 2 : 300;
    }

    btnPrev.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    btnNext.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    /* Update arrow + fade state */
    function updateState() {
      var sl  = Math.round(track.scrollLeft);
      var max = track.scrollWidth - track.clientWidth;

      var atStart = sl <= 2;
      var atEnd   = sl >= max - 2;

      btnPrev.disabled = atStart;
      btnNext.disabled = atEnd;

      scroller.classList.toggle('is-at-start', atStart);
      scroller.classList.toggle('is-at-end',   atEnd);
    }

    track.addEventListener('scroll', updateState, { passive: true });

    /* Re-check on resize (cards may reflow) */
    if (window.ResizeObserver) {
      new ResizeObserver(updateState).observe(track);
    } else {
      window.addEventListener('resize', updateState);
    }

    /* Initial state */
    updateState();
  }

  /* ── Copy helper ── */
  function copyCode(btn) {
    var code = btn.dataset.code;
    if (!code) return;
    var orig = btn.textContent.trim();

    function onSuccess() {
      btn.textContent = '✓ COPIED';
      btn.classList.add('is-copied');
      btn.setAttribute('aria-label', 'Code copied!');
      clearTimeout(btn._resetTimer);
      btn._resetTimer = setTimeout(function () {
        btn.textContent = orig;
        btn.classList.remove('is-copied');
        btn.setAttribute('aria-label', 'Copy code ' + orig);
      }, 2000);
    }

    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(onSuccess).catch(function () {
        fallbackCopy(code, onSuccess);
      });
    } else {
      fallbackCopy(code, onSuccess);
    }
  }

  function fallbackCopy(text, cb) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    try { if (document.execCommand('copy')) cb(); } catch (e) {}
    document.body.removeChild(ta);
  }

  /* ── Tooltip helpers ── */
  function showTip(tooltip, text, cx, cy) {
    if (!text) return;
    tooltip.textContent = text;
    tooltip.style.setProperty('--tip-arrow-left', '50%');
    tooltip.style.left = '0px';
    tooltip.style.top  = '0px';

    requestAnimationFrame(function () {
      var w  = tooltip.offsetWidth;
      var h  = tooltip.offsetHeight;
      var vw = window.innerWidth;

      var left = cx - w / 2;
      var top  = cy - h - 14;

      var clampedLeft = Math.max(8, Math.min(left, vw - w - 8));
      var arrowOffset = cx - clampedLeft;
      arrowOffset = Math.max(10, Math.min(arrowOffset, w - 10));
      tooltip.style.setProperty('--tip-arrow-left', arrowOffset + 'px');

      if (top < 8) {
        top = cy + 20;
        tooltip.style.setProperty('--tip-arrow-left', '-9999px');
      }

      tooltip.style.left = clampedLeft + 'px';
      tooltip.style.top  = top + 'px';
      tooltip.classList.add('is-visible');
      tooltip.setAttribute('aria-hidden', 'false');
    });
  }

  function hideTip(tooltip) {
    tooltip.classList.remove('is-visible');
    tooltip.setAttribute('aria-hidden', 'true');
  }

  /* ── Bootstrap ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.cs-pdp-offers');
    if (el) setup(el);
  });
})();
